// ARGOS screen help (the "?" at the top of ARGOS). Plain words; keep it in step with
// the screen (apps/mobile/src/tools/ArgosTool.tsx): tabs, card titles and labels must match.
import type { ScreenHelpContent } from '../../v10/ScreenHelp';

export const argosHelp: ScreenHelpContent = {
  title: 'A.R.G.O.S',
  intro:
    "A.R.G.O.S shows what you actually did online, so you can catch drift early. The ARGOS browser extension records your browsing and sends it here. You can't type anything into this screen. You just read it.",
  sections: [
    {
      heading: 'Pick the time',
      body: ['The first row of buttons sets the period for everything below. Today, This Week (from Monday) or This Month.'],
    },
    {
      heading: 'Overview',
      body: ['The default tab. Each card answers one question. If nothing was recorded in the period, you see "No activity data for this period" and a reminder to install the ARGOS extension.'],
      items: [
        { term: 'Activity by Category', text: 'a pie chart of where your time went. The list beside it gives each category its share.' },
        { term: 'Time of Day', text: 'bars for Morning, Afternoon, Evening and Night. Each bar is split by category, so you can see when drift happens.' },
        { term: 'Daily Timeline', text: 'one line per category, one point per day, in minutes. Swipe sideways if there are many days.' },
        { term: 'Sources', text: 'which browser or device the time came from.' },
        { term: 'Top Domains', text: 'your 10 biggest websites, with total time and number of sessions.' },
        { term: 'Block Events', text: 'sites the extension blocked. It shows how many were today and how many in this period, with the reason. "Overridden" means you went through anyway.' },
      ],
    },
    {
      heading: 'Deep Dive',
      body: ['The second tab has three smaller views.'],
      items: [
        { term: 'Shopping', text: 'products you looked at: name, type, site, price and date, plus an estimated spend for the period.' },
        { term: 'Extra', text: 'totals only for categories marked as sensitive: Total Duration, Sessions, and minutes by time of day. No site names or page titles are shown, to protect your privacy.' },
        { term: 'Patterns', text: 'press Generate Patterns and an AI reads the last 7 days of your activity and writes a few short observations. It does not get the names of sensitive sites. Press Regenerate for a fresh set.' },
      ],
    },
    {
      heading: 'How to use it',
      body: [
        'Look at Overview first. Which category has the most time? When in the day does it happen?',
        'Then check Top Domains for the exact sites.',
        'If you see drift, pick one small fix, such as moving that habit to a later time of day, and add it as a task in KYRS.',
        'Categories, limits and blocking rules are not changed here. Those are in Settings.',
      ],
    },
    {
      heading: 'Saving',
      body: ['Nothing to save. The screen only reads what the extension recorded. The period you picked is not remembered when you leave.'],
    },
  ],
};
